import RequiredSkills from './RequiredSkills'
export default RequiredSkills
